import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  deleteWithdrawalRequest: ["withdrawal_id"],
  deleteWithdrawalSuccess: ["Status"],
  deleteWithdrawalFailure: null,
});

export const DeleteWithdrawalTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  withdrawal_id: null,
  fetching: null,
  success: null,
  error: null,
  Status: null,
});

export const DeleteWithdrawalSelectors = {
  getData: (state: any) => state.deleteWithdrawal.data,
  isFetching: (state: any) => state.deleteWithdrawal.fetching,
  isSuccess: (state: any) => state.deleteWithdrawal.success,
  hasError: (state: any) => state.deleteWithdrawal.error,
};

export const request = (state: any, { withdrawal_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    withdrawal_id: withdrawal_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { Status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    Status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DELETE_WITHDRAWAL_REQUEST]: request,
  [Types.DELETE_WITHDRAWAL_SUCCESS]: success,
  [Types.DELETE_WITHDRAWAL_FAILURE]: failure,
});
